import React, { useRef, useEffect, useState } from 'react';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import "./SubscriptionAgreement.scss"

const SubscriptionAgreement = () => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }: any) {
        setNumPages(numPages);
    }

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Flight Watcher T&Cs for Travel Agencies, Airlines or Travelers</title>
                    <meta name='description' content='Get "Flight Watcher" for flight delay, cancellation and be the first one to choose alternative airlines, nearby airports, re-booking, or re-accommodation by your airline.' />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='subscription-agreement-container container-side-padding container-content-padding'>
                <div className='container no-padding text-justify'>
                    <h2 className='pdf-header'>AirLegit Subscription Account Agreement</h2>
                    <div className="pdf-wrapper">
                        <iframe src="https://airlegit.com/assets/documents/Subscription-Agreement.pdf" style={{ height: "100%", width: "100%" }}>
                        </iframe>
                    </div>
                </div>

            </div>
            <Contact />
            <Footer />
        </>
    );
};
export default SubscriptionAgreement;